import { Command as CommandPrimitive } from 'cmdk';
import { forwardRef } from 'react';
import { cn } from '@/shared/lib/utils';

export const CommandRoot = forwardRef<
  React.ElementRef<typeof CommandPrimitive>,
  React.ComponentPropsWithoutRef<typeof CommandPrimitive>
>(({ className, ...props }, ref) => (
  <CommandPrimitive
    ref={ref}
    className={cn(
      'flex h-full w-full flex-col overflow-hidden rounded-md text-popover-foreground',
      className,
    )}
    {...props}
  />
));

CommandRoot.displayName = CommandPrimitive.displayName;
